/**
 * Page d'inscription - React Vite
 */

import { useNavigate } from 'react-router-dom';
import { RegisterForm } from '../components/forms/RegisterForm';

export function RegisterPage() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/auth/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-content">
            Créer un compte
          </h2>
          <p className="mt-2 text-center text-sm text-content-muted">
            Inscrivez-vous pour accéder à l'application
          </p>
        </div>
        <div className="bg-surface rounded-lg shadow-lg p-8">
          <RegisterForm onSuccess={handleSuccess} />
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
